<template>
  <div v-if="upcomingMarkets && upcomingMarkets.length" class="upcoming-match">
    <v-sheet tile class="px-4 padding-fix">
      <section-head
        title="Upcoming"
        theme="white"
        icon="mdi-sort-clock-descending"
        :hide-divider="true"
        :hide-icons="false"
      />
    </v-sheet>
    <upcoming-matches />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SectionHead from '@/components/SectionHead'
import UpcomingMatches from '@/components/UpcomingMatches'
export default {
  name: 'Inplay',
  components: { SectionHead, UpcomingMatches },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      upcomingMarkets: (state) => state.inplay.upcomingMarkets
    })
  },

  methods: {}
}
</script>
<style lang="scss" scoped>
.item-odds {
  + .item-odds {
    border-top: 1px solid #e0e0e0;
  }
}
.padding-fix {
  display: inline-block;
  padding-right: 40px !important;
}
.v-sheet {
  background: #121212;
}
</style>
